<div style="height: 100%" [class]="hostClass">
  <div class="container-fluid d-flex justify-content-center justify-content-lg-start align-items-center sp-h-100">
    <div class="sp-wrapper">
      <div class="sp-brand">
        <span class="text-hide">
          <span class="sp-brand-name">SoPrism</span>
          <span class="sp-brand-slogan">Social audience for marketing intelligence</span>
          <img alt="" class="sp-brand-logo" style="width: 154px;" src="assets/images/logos/audiense/soprism-new-logo.svg" />
        </span>
      </div>
      <h1>{{ title }}</h1>
      <h2>{{ subtitle }}</h2>
      <hr />
      <ng-content></ng-content>
      <a class="d-lg-none d-xl-none btn btn-primary sp-btn sp-btn-primary text-uppercase" (click)="onButtonClick()" type="button" *ngIf="showActionButton">
        <span>{{ buttonText }}</span>
      </a>
      <a (click)="onButtonClick()" class="d-none d-lg-inline-block d-xl-inline-block btn btn-primary btn-lg sp-btn sp-btn-primary sp-btn-lg text-uppercase" type="button" *ngIf="showActionButton">
        <span>{{ buttonText }}</span>
      </a>
    </div>
  </div>
</div>
